/**
 * 公開までの流れの絵（使い方ガイドの始め方 3・2026-10-19 design/visual-guides・founder「文字ばっかりだな」）。
 * テスト版 →「公開して」→ KUMODeck のページで 1 回だけ確かめる → みんなが開ける、の 4 段。部品と見た目は ConnectPictures と同じ（.cp-*）= 新しい見た目を増やさない。
 * 事実は guide.start.publish.body と同じ（AI はまずテスト版に出す・公開の前に 1 回だけ確認 = MCP / CLI の確認のページ confirmAction.button.publish）。
 * 住所は書かない（ドメインを直書きしない）= 窓のアドレスの欄は「your-app」と札だけ。押す所は 1 枚に 1 つ（.cp-hot）
 */
import type { ReactNode } from 'react';
import { useT, type MessageKey } from '../i18n';
import { PRODUCT_NAME } from '../productName';

const STEPS = ['test', 'say', 'confirm', 'live'] as const;

export function PublishFlow() {
  const { t } = useT();
  const vars = { product: PRODUCT_NAME };
  return (
    <ol className="cp-steps cp-flow">
      {STEPS.map((s, i) => (
        <li key={s} className="cp-step">
          <span className="cp-art" role="img" aria-label={t(`guide.flow.alt.${s}` as MessageKey, vars)}>
            <Pic step={s} />
          </span>
          <span className="cp-cap">
            <span className="cp-n" aria-hidden="true">
              {i + 1}
            </span>
            {t(`guide.flow.${s}` as MessageKey, vars)}
          </span>
        </li>
      ))}
    </ol>
  );
}

function Win({ where, children }: { where: string; children: ReactNode }) {
  return (
    <span className="cp-win is-web">
      <span className="cp-bar">
        <i />
        <i />
        <i />
        <span className="cp-where">{where}</span>
      </span>
      <span className="cp-body">{children}</span>
    </span>
  );
}

/** 作ったアプリの代わりの絵（空と地面と丸 = ゲームでもアプリでも読める形） */
const App = ({ tag, live = false }: { tag: string; live?: boolean }) => (
  <span className="cp-app">
    <span className={`cp-tag ${live ? 'is-live' : ''}`}>{tag}</span>
    <span className="cp-app-sun" />
    <span className="cp-app-ground" />
  </span>
);

function Pic({ step }: { step: (typeof STEPS)[number] }) {
  switch (step) {
    case 'test':
      return (
        <Win where="your-app (test)">
          <App tag="Test version" />
        </Win>
      );
    case 'say':
      return (
        <Win where="AI">
          <span className="cp-convo">
            <span className="cp-line is-short" />
            <span className="cp-composer">
              <span className="cp-typed">publish it</span>
              <span className="cp-send cp-hot">↑</span>
            </span>
          </span>
        </Win>
      );
    case 'confirm':
      return (
        <Win where={PRODUCT_NAME}>
          <span className="cp-page">
            <b className="cp-h">Publish your-app?</b>
            <span className="cp-line is-short" />
            <span className="cp-actions">
              <span className="cp-btn">Cancel</span>
              <span className="cp-btn is-primary cp-hot">Publish</span>
            </span>
          </span>
        </Win>
      );
    case 'live':
      return (
        <Win where="your-app">
          <App tag="Public" live />
        </Win>
      );
  }
}
